// client/src/components/layout/MainLayout.js
import React, { useState } from 'react';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import styles from './MainLayout.module.scss'; // 1. Importando o SCSS Module

const MainLayout = ({ children }) => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

    const [isCollapsed, setIsCollapsed] = useState(() => localStorage.getItem('sidebarCollapsed') === 'true');
    const toggleCollapse = () => {
        setIsCollapsed(prev => {
            const next = !prev;
            localStorage.setItem('sidebarCollapsed', String(next));
            return next;
        });
    };

    // 2. Lógica para aplicar classes condicionalmente
    const contentWrapperClass = `${styles.mainContentWrapper} ${sidebarOpen ? '' : styles.sidebarPresent} ${isCollapsed ? styles.sidebarCollapsed : ''}`;

    // Adicionamos a classe 'is-open' ao corpo do documento para evitar scroll quando o menu está aberto em mobile
    if (sidebarOpen) {
        document.body.classList.add('no-scroll');
    } else {
        document.body.classList.remove('no-scroll');
    }

    return (
        <div className={styles.appLayout}>
            <Sidebar
                isOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
                isCollapsed={isCollapsed}
                toggleCollapse={toggleCollapse}
            />

            <div className={contentWrapperClass}>
                <TopBar toggleSidebar={toggleSidebar} />
                <main className={styles.pageContentArea}>
                    <div className={styles.pageContainer}>
                        {children}
                    </div>
                </main>
            </div>
            
            
            {sidebarOpen && <div onClick={toggleSidebar} className={styles.mobileOverlay}></div>}
        </div>
    );
};

export default MainLayout;